export function polyfillAccountIdPrefix(sourceId: string, accountId: string): string {
  // If accountId already starts with 2 letters, return as is
  if (/^[A-Za-z]{2}/.test(accountId)) {
    return accountId;
  }
  if (sourceId === 'ebay') {
    return `EB${accountId}`;
  }
  if (sourceId === 'prestashop') {
    return `PR${accountId}`;
  }
  return `II${accountId}`;
}
